import { Box, Heading, Text, VStack } from "@chakra-ui/react";

export default function TermsAndConditionsPage() {
  return (
    <Box maxW="800px" mx="auto" p={6}>
      <Heading as="h1" mb={4}>
        Terms and Conditions
      </Heading>
      {/* <Text fontSize="sm" color="gray.500" mb={4}> */}
      {/*   Last updated: [Insert Date] */}
      {/* </Text> */}
      <VStack align="start" spacing={4}>
        <Text>
          Welcome to SL Teach (“we”, “our”, “us”). These Terms and Conditions
          (“Terms”) govern your use of our learning management system
          (“Platform”), which provides access to class recordings and question
          papers, along with online payment processing. By using our Platform,
          you agree to these Terms. If you do not agree, please do not use the
          Platform.
        </Text>

        <Heading as="h2" size="md">
          1. Account Registration
        </Heading>
        <Text>
          You must create an account to access any part of the Platform. You
          agree to provide accurate, complete, and current registration details.
          You are responsible for keeping your account credentials confidential.
          You are fully responsible for all activities under your account.
        </Text>

        <Heading as="h2" size="md">
          2. Services
        </Heading>
        <Text>
          Our Platform offers:
          <br />
          - Access to pre-recorded classes (view-only; no downloads).
          <br />
          - Access to question papers (view-only; no downloads).
          <br />
          - Monthly payment system (no subscriptions; you must pay manually each
          month to maintain access).
          <br />
          We reserve the right to update or discontinue any service at any time.
        </Text>

        <Heading as="h2" size="md">
          3. Payments
        </Heading>
        <Text>
          All payments are processed in EURO (€).
          <br />
          Accepted payment methods include:
          {/* <br /> */}
          {/* - Stripe (international card payments). */}
          <br />
          - Commercial Bank Payment Gateway.
          <br />
          Payments must be made manually each month; we do not offer automatic
          subscriptions or recurring billing.
          <br />
          Payments are non-refundable, except as required by law.
        </Text>

        <Heading as="h2" size="md">
          4. Refund Policy
        </Heading>
        <Text>
          We do not provide refunds for:
          <br />
          - Accessed or viewed recordings.
          <br />
          - Accessed question papers.
          <br />
          - Missed payments or user error.
          <br />
          If you encounter technical issues preventing access after payment,
          please contact our support team promptly.
        </Text>

        <Heading as="h2" size="md">
          5. Intellectual Property
        </Heading>
        <Text>
          All content on the Platform, including videos, question papers, and
          materials, is the property of SL Teach or its licensors.
          <br />
          You may only view content for personal, educational use.
          <br />
          Downloading, copying, distributing, or sharing any Platform content is
          strictly prohibited.
        </Text>

        <Heading as="h2" size="md">
          6. User Conduct
        </Heading>
        <Text>
          By using the Platform, you agree:
          <br />
          - Not to share your account credentials with others.
          <br />
          - Not to attempt to download or redistribute any content.
          <br />
          - Not to engage in any illegal, harmful, or disruptive activity on the
          Platform.
          <br />
          Violation of these rules may result in immediate suspension or
          termination of your account.
        </Text>

        <Heading as="h2" size="md">
          7. Limitation of Liability
        </Heading>
        <Text>
          We aim to provide reliable services but do not guarantee the Platform
          will be error-free or available at all times.
          <br />
          We are not liable for:
          <br />
          - Technical issues beyond our control.
          <br />
          - Payment processing errors by third-party providers.
          <br />- Unauthorized access resulting from your failure to secure your
          account.
        </Text>

        <Heading as="h2" size="md">
          8. Privacy
        </Heading>
        <Text>
          Your use of the Platform is governed by our (
          <a
            href="/admin/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Privacy Policy
          </a>
          ). By using the Platform, you consent to our collection and use of
          your data as described there.
        </Text>

        <Heading as="h2" size="md">
          9. Changes to Terms
        </Heading>
        <Text>
          We may update these Terms periodically. We will notify you of major
          changes via email or Platform notifications. Continued use after such
          updates indicates your acceptance of the revised Terms.
        </Text>
      </VStack>
    </Box>
  );
}
